import React, {Component} from 'react';

class Template extends Component{

  render(){
    return(
      <div>
        <div className='title'>{__('Poster Templates', 'createposter')}</div>
        <div className='row'>
          <div className='col-xs-6'>
            <div className='template' />
            <div className='template' />
            <div className='template' />
          </div>
          <div className='col-xs-6'>
            <div className='template' />
            <div className='template' />
            <div className='template' />
          </div>
        </div>
      </div>
    )
  }
}


export default Template



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/Template.js